import LogoSVG from "assets/svg/Logo.png"

const Logo = () => {
    return(
        <img src={LogoSVG} width={'100%'} alt="logo ayude" className="Logo-tc"/>
    )
}

export default Logo;